<template>
  <line-chart
    class="fill-height"
    :raw-data="periods"
    type="bar"
    :chart-value-keys="[
      { key: 'CAPGCSDCB13EG2', type: 'bar', label: $t('chart_legends.deceleration_less_-4') },
      { key: 'UXDCB13', type: 'bar', label: $t('chart_legends.deceleration_less_-3') },
      { key: 'UXDCB14', type: 'bar', label: $t('chart_legends.deceleration_less_-2') },
      { key: 'UXACB58', type: 'bar', label: $t('chart_legends.accelerations_more_2') },
      { key: 'UXACB68', type: 'bar', label: $t('chart_legends.accelerations_more_3') },
      { key: 'CAPGCSACB13EG2', type: 'bar', label: $t('chart_legends.accelerations_more_4') },
    ]"
    x-value="title"
    y-value-prefix="teams[0].team_stats."
    :xaxis="{
      labels: {
        rotate: -45
      },
      tickPlacement: 'between'
    }"
    :stacked="true"
    :colors="[ '#ff0000', '#ff6666', '#ff9999', '#1affb2', '#00e396', '#00b377']"
    :fill="{ opacity: [1, 1, 1, 1, 1, 1]}"
  >
    <template v-slot:header>
      <v-card-title class="pa-6 d-flex justify-space-between">
        <div class="subtitle-2 grey--text text--grey-100">
          {{ $t('card_title.accelerations_and_decelerations') }}
        </div>
      </v-card-title>
    </template>
  </line-chart>
</template>

<script>
import LineChart from '@/components/charts/LineChart'

export default {
  name: 'AccelerationsDecelerationsPeriodChart',
  components: { LineChart },
  props: {
    periods: {
      type: Array,
      required: true
    },
    chart: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    removable: {
      type: Boolean,
      default: false
    }
  }
}
</script>
